export const adminRoutes = [
    {
        path: "/admin/login",
        name: "admin-login",
        component: () => import("@/layouts/AdminLoginLayout.vue"),
        children: [
            {
                path: "",
                component: () => import("@/views/admin/AdminLoginPage.vue"),
            },
        ],
    },
    {
        path: "/admin",
        component: () => import("@/layouts/AdminAuthLayout.vue"),
        meta: { requiresAdminAuth: true },
        children: [
            { path: "", redirect: "/admin/proposals" },
            {
                path: "proposals",
                name: "admin-proposals",
                component: () =>
                    import("@/views/admin/proposal/ProposalsPage.vue"),
            },
            {
                path: "proposals/create",
                name: "admin-proposal-create",
                component: () =>
                    import("@/views/admin/proposal/ProposalCreatePage.vue"),
            },
            {
                path: "proposals/:uuid",
                name: "admin-proposal-detail",
                component: () =>
                    import("@/views/admin/proposal/ProposalDetailPage.vue"),
                props: true,
            },
            // Legacy edit URL → consolidated into the detail page (inline edit).
            {
                path: "proposals/:uuid/edit",
                redirect: (to) => `/admin/proposals/${to.params.uuid}`,
            },
            {
                path: "niches",
                name: "admin-niches",
                component: () =>
                    import("@/views/admin/niche/NichesPage.vue"),
            },
            {
                path: "niches/:id",
                name: "admin-niche-detail",
                component: () =>
                    import("@/views/admin/niche/NicheDetailPage.vue"),
                props: true,
            },
            {
                path: "freelancers",
                name: "admin-freelancers",
                component: () =>
                    import("@/views/admin/freelancer/FreelancersPage.vue"),
            },
            {
                path: "interviews",
                name: "admin-interviews",
                component: () =>
                    import("@/views/admin/interview/InterviewsPage.vue"),
            },
            {
                path: "availability",
                name: "admin-availability",
                component: () =>
                    import("@/views/admin/availability/AvailabilityPage.vue"),
            },
        ],
    },
];
